import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../../../common/Heading/head';

const Heading = (props) => {
  const { heading } = props;
  return (
    <Header heading={heading} />
  );
}

Heading.propTypes = {
  heading: PropTypes.string,
};

export default Heading;
